import { useTranslation } from 'react-i18next';
import DurationField from '@/components/fields/DurationField';

const FinSwimInnerForm = () => {
    const { t } = useTranslation('performanceResult');

    return (
        <div className="sm:col-span-2">
            <DurationField
                name="completionTime"
                units={['minutes', 'seconds']}
                label={t('finSwim.form.completionTime')}
                target="seconds"
            />
        </div>
    );
};

export default FinSwimInnerForm;
